import { cn } from "@/lib/utils";

import PageTitle, { PageTitleProps } from "@/components/Common/PageTitle";
import { useShortcutSubContext } from "@/context/ShortcutContext";

interface PageProps extends PageTitleProps {
  children: React.ReactNode | React.ReactNode[];
  options?: React.ReactNode | React.ReactNode[];
  changePageMetadata?: boolean;
  className?: string;
  hideTitleOnPage?: boolean;
  shortCutContext?: string;
  style?: React.CSSProperties;
}

/** Page frame: one compact header row (title, count, actions) above the content. */
export default function Page(props: PageProps) {
  useShortcutSubContext(props.shortCutContext);
  const showHeader = !props.hideTitleOnPage || !!props.options;

  return (
    <div className={cn("py-0", props.className)} style={props.style}>
      {showHeader && (
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <PageTitle
            changePageMetadata={props.changePageMetadata}
            title={props.title}
            componentRight={props.componentRight}
            isInsidePage={true}
            hideTitleOnPage={props.hideTitleOnPage}
          />
          {props.options && (
            <div className="flex flex-wrap items-center gap-2">
              {props.options}
            </div>
          )}
        </div>
      )}
      {!showHeader && props.changePageMetadata !== false && (
        <PageTitle
          changePageMetadata={props.changePageMetadata}
          title={props.title}
          isInsidePage={true}
          hideTitleOnPage
        />
      )}
      {props.children}
    </div>
  );
}
